// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table__tableWrapper {
  height: 100%;
  width: 100%;
  overflow: auto;
  container-type: inline-size;

  &>table {
    width: 100%;
    height: auto;
    border-collapse: collapse;
    table-layout: fixed;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Table/table.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,2BAA2B;;EAE3B;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;EACrB;AACF","sourcesContent":[".tableWrapper {\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  container-type: inline-size;\n\n  &>table {\n    width: 100%;\n    height: auto;\n    border-collapse: collapse;\n    table-layout: fixed;\n  }\n}"],"sourceRoot":""}]);
// Exports
export var tableWrapper = `table__tableWrapper`;
export default ___CSS_LOADER_EXPORT___;
